import api from './client';
import type { 
  UsuariosResponse,
  UsuariosFilters,
  Usuario,
  CriarUsuarioRequest,
  AtualizarUsuarioRequest,
  AlterarStatusRequest,
  RedefinirSenhaRequest,
  AlterarSenhaRequest,
  EstatisticasResponse,
  SimpleResponse
} from '../types/usuarios';

class UsuariosApi {
  // Listar usuários com filtros e paginação
  async getUsuarios(filters: UsuariosFilters = {}) {
    const params = new URLSearchParams();
    
    if (filters.search) {
      params.append('search', filters.search);
    }
    if (filters.perfil) {
      params.append('perfil', filters.perfil);
    }
    if (filters.ativo !== undefined) {
      params.append('ativo', filters.ativo.toString());
    }
    if (filters.page) {
      params.append('page', filters.page.toString());
    }
    if (filters.pageSize) {
      params.append('pageSize', filters.pageSize.toString());
    }

    const queryString = params.toString();
    const url = `/usuarios${queryString ? `?${queryString}` : ''}`;
    
    return api.get<UsuariosResponse>(url);
  }

  // Obter usuário por ID
  async getUsuario(id: number) {
    return api.get<{ success: boolean; data: Usuario; message: string }>(`/usuarios/${id}`);
  }

  // Criar novo usuário
  async criarUsuario(data: CriarUsuarioRequest) {
    return api.post<{ success: boolean; data: Usuario; message: string }>('/usuarios', data);
  }

  // Atualizar usuário
  async atualizarUsuario(id: number, data: AtualizarUsuarioRequest) {
    return api.put<{ success: boolean; data: Usuario; message: string }>(`/usuarios/${id}`, data);
  }

  // Alterar status (ativar/desativar)
  async alterarStatus(id: number, data: AlterarStatusRequest) {
    return api.patch<SimpleResponse>(`/usuarios/${id}/status`, data);
  }

  // Redefinir senha de usuário
  async redefinirSenha(id: number, data: RedefinirSenhaRequest) {
    return api.post<SimpleResponse>(`/usuarios/${id}/reset-senha`, data);
  }

  // Alterar própria senha
  async alterarSenha(data: AlterarSenhaRequest) {
    return api.post<SimpleResponse>('/usuarios/alterar-senha', data);
  }

  // Alterar senha de usuário manualmente (admin)
  async alterarSenhaManual(id: number, data: RedefinirSenhaRequest) {
    return api.put<SimpleResponse>(`/usuarios/${id}/alterar-senha-manual`, data);
  }

  // Obter estatísticas
  async getEstatisticas() {
    return api.get<EstatisticasResponse>('/usuarios/estatisticas');
  }

  // Permissões
  async getPermissoesDisponiveis() {
    return api.get<Array<{ chave: string; label: string }>>('/usuarios/permissoes/disponiveis');
  }

  async getPermissoesUsuario(id: number) {
    return api.get<string[]>(`/usuarios/${id}/permissoes`);
  }

  async salvarPermissoes(id: number, permissoes: string[]) {
    return api.put(`/usuarios/${id}/permissoes`, permissoes);
  }
}

export const usuariosApi = new UsuariosApi();